/**
 * Stacking layers for fixed chrome. ONE rule: every modal, dialog, sheet and
 * drawer sits above the mobile bottom nav.
 *
 * The bars used to sit at 50 — the same layer as the modals — and the app
 * shell renders the bar AFTER the routed page, so at equal layers the bar won
 * and was drawn over a dialog's footer buttons at phone width (fe#837 found it
 * on MergeContactDialog; ConfirmModal and MergeCustomerDialog had the same
 * defect). Every overlay in src/ is at 50 or above, so the fix lives here, on
 * the bars, rather than in each of ~95 overlays.
 *
 * Floating buttons and toasts also sit at 40, at --fab-bottom — above the bar
 * in space, so the shared layer never overlaps.
 */
export const BOTTOM_NAV_Z = 40;

/** The layer every overlay uses (the `z-50` utility). Must stay above BOTTOM_NAV_Z. */
export const MODAL_Z = 50;

/**
 * The icon-button tooltip (`components/ui/tooltip.tsx`). Above the overlay
 * layer, because the buttons most in need of a label sit inside dialogs too.
 * It is `pointer-events: none`, so sitting on top can never block a click.
 */
export const TOOLTIP_Z = 60;
